export const SrCitizenConcessions = Object.freeze({
  FULL_CONCESSION: {
    key: true,
    value: 'I want 100% concession',
    displayText: '100% sr. citizen concession',
  },
  NO_CONCESSION: {
    key: false,
    value: 'I don\'t want concession',
    displayText: 'No senior citizen concession',
  },
});

export const SrCitizenConcessionValues =
  [ SrCitizenConcessions.FULL_CONCESSION, SrCitizenConcessions.NO_CONCESSION ];

export const getSrCitizenOptions = () =>
  Object.values(SrCitizenConcessions).map((srCitizenConcession) => ({
    id: `${srCitizenConcession.key}`,
    text: srCitizenConcession.displayText,
    obj: srCitizenConcession,
  }));
